import { useState } from 'react';

export const useContractType = (defaultValue: string = '') => {
  const [selectedType, setSelectedType] = useState(defaultValue);

  const handleTypeChange = (type: string) => {
    setSelectedType(type);
  };

  const resetType = () => {
    setSelectedType(defaultValue);
  };

  return {
    selectedType,
    handleTypeChange,
    resetType,
  };
};
